export enum ContentType {
    Root = 'root',
    Page = 'page',
    Text = 'text',
    BlogPost = 'blogPost',
    Project = 'project',
    Html = 'html',
    ImageJpeg = 'image/jpeg',
    Layout = 'layout',
    Header = 'header',
    Card = 'card',
    Section = 'section'
}